import {createSlice} from "@reduxjs/toolkit";

const initialPopupAddReceipt = {
  dataLoading: false,
  entities: [],
  error: null,
  disabledFields: [],
  parsedUploadedAgents: [],
  failedUploadedAgents: [],
};
export const callTypes = {
  data: "data",
  action: "action"
};

export const popupAddReceiptSlice = createSlice({
  name: "popupAddReceipt",
  initialState: initialPopupAddReceipt,
  reducers: {
    popupAddReceiptFetched: (state, action) => {
      const {entities} = action.payload;
      state.dataLoading = false;
      state.error = null;
      state.entities = entities;
    },
    saveDisabledFields: (state, action) => {
      const {disabledFields} = action.payload;
      state.disabledFields = disabledFields;
    },
    uploadedAgentsFetched: (state, action) => {
      const {parsedUploadedAgents, failedUploadedAgents} = action.payload;
      state.parsedUploadedAgents = parsedUploadedAgents;
      state.failedUploadedAgents = failedUploadedAgents;
      state.error = null;
    },
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.data) {
        state.dataLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.addReceiptError = null;
      if (action.payload.callType === callTypes.data) {
        state.dataLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  }
});
